import { Component, OnInit, Input, ViewChild, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { Site } from 'solar-bo';;
import { OlMainComponent, OlMapOptions } from 'gmap';
import * as ol_style from 'ol/style';
import GeoJSON from 'ol/format/GeoJSON';
import { MapSiteHelper, MapIssueOverlay } from '@solar/ol';
import { FrLayer } from 'gmap';
import { SolarBaseComponent } from '@solar/solar/solar-base';
import { MapOnMoveHelper } from 'gmap';
import { MapSupervisionIssues } from '@solar/ol';
import { OlObjectTypeEnum, Panel } from 'solar-bo';
import { PanelViewComponent } from '../../panel/panelview.component';
import { mapcte } from 'gmap';
import { MapPanelStyle } from '@solar/ol';
import { MapPanelSourceHelper } from '@solar/ol/map-panel-source-helper';
import { UUIDHelper } from '@solar/shared/uuidhelper.model';
import { PanelLayerAddComponent } from './panel-layer-add/panel-layer-add.component';
import { UploadSimpleFileComponent } from '@solar/components/upload-simple-file/upload-simple-file.component';



@Component({
  selector: 'app-ex-site-map',
  templateUrl: './site-map.component.html',
  styleUrls: ['./site-map.component.scss']
})
export class SiteMapComponent extends SolarBaseComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() site: Site;
  @ViewChild('map', { static: true }) mapc: OlMainComponent;


  //actions
  editAction: LayerEditAction = new LayerEditAction();
  editLayersIsRunning: boolean = false;
  editSaveButtonDesc: string;
  editSaveButtonToolTip: string;
  editCancelButtonDesc: string;
  editCancelButtonToolTip: string;

  //map
  mapcomponent_options: OlMapOptions = new OlMapOptions({ zoomPosition: 'LEFT' ,showCoords: true });

  siteLayer: any;
  panelLayer: MapPanelSourceHelper = new MapPanelSourceHelper();
  mapInitialized: boolean = false;
  mapVisible = true;
  featureOverlay: any;
  mapPanelStyle: MapPanelStyle = new MapPanelStyle();
  /**
   * zoom level at wich show the panels
   */
  mapPanelsZoomMin = 19.5;

  sitelimitschange: boolean = false;

  constructor() {
    super();
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {

  }
  ngAfterViewInit() {
    console.log("SiteMapComponent-ngAfterViewInit");
    if (this.mapc) {
      this.mapInitialized = true;
      this.loadDeferer();
    }
  }
  /**
   * load data with timeout to avoid flikering in tabs
   */
  private loadDeferer() {
    let cls=this;
    setTimeout(function () {
      cls.loadData();
    }.bind(this), 100);

  }

  private loadData() {
    try {

      if (this.site != null) {
        MapSiteHelper.drawSitesOnMap(this.mapc, this.site.name, "sitemarker_" + this.site.id, [this.site]);

        if (this.site.info.location) {
          this.mapc.setLocation(this.site.info.location);
        }

        if (this.site.geom) {
          this.siteLayer = MapSiteHelper.loadSiteGeometry("Site boundary", this.site.geom, "geom_" + this.site.id);
          this.mapc.layerAdd(this.siteLayer);
          this.mapc.setZoomToExtent(this.siteLayer);
        }

        this.alertmessage = null;
        let zoomExtent = this.mapc.getZoom();
        if (zoomExtent < this.mapPanelsZoomMin) {
          //this.showmessage("In order to be able to see the panels you must zoom");
        }
        this.map_loadSitePanels(this.site);
        this.loading = false;
      }
    }
    catch (err) {
      this.showerror("Error loading site map.",err);
      this.loading = false;
    }
  }
  /**
   * load site panels
   * @param site 
   */
  private map_loadSitePanels(site: Site) {
    this.mapConfigListeners();
    this.panelLayer.loadingEvent.subscribe(res => this.panelLoadingHandler(res));
    let panelsLayer = this.panelLayer.loadSitePanelsMap(true, this.mapPanelsZoomMin, site.info.panel_locator_pattern.maps);
    this.mapPanelStyle.panel_pattern = site.info.panel_locator_pattern.maps;
    panelsLayer.setStyle(this.mapPanelStyle.panelsFilterStyle.bind(this.mapPanelStyle));

    panelsLayer.setZIndex(100);
    let layerinfo: FrLayer = panelsLayer[mapcte.frlayerinfo_FieldName];
    this.panelOverlay.layersId.push(layerinfo.id);
    this.mapc.map.addLayer(panelsLayer);
  }

  panelLoadingHandler(res) {
    if (res == "LOADING") {
      this.mapc.loadinglist = true;
      this.mapc.showmessage("Loading panels, please wait");
    } else if (res == "LOADING_END") {
      this.mapc.loadinglist = false;
      this.mapc.alertmessage = null;

    } else if (res == "LOADING_END_ERROR") {
      this.mapc.loadinglist = false;
      this.mapc.alertmessage = null;
      this.showNotificationError("An error ocurred loading panels.");
    }
  }


  logtest() {
    console.log("Zoom: " + this.mapc.zoomUpdateManually());
  }

  layersShowPanel() {
    this.mapc.layersShowPanel();
  }

  //map
  panelOverlay: MapIssueOverlay;
  tooltipOverlay: MapIssueOverlay;
  mapOnMoveHelper: MapOnMoveHelper;
  mapSupervisionIssues: MapSupervisionIssues;
  /**
   * config listeners for map
   */
  private mapConfigListeners() {
    this.mapc.onFeatureClick.subscribe(res => this.map_onFeatureClick(res));
    this.mapOnMoveHelper = new MapOnMoveHelper(this.mapc);
    this.panelOverlay = new MapIssueOverlay(this.mapc);
    this.mapOnMoveHelper.addListener(this.panelOverlay);
  }
  /**
   * controls when click on map
   * @param features 
   */
  map_onFeatureClick(features: any[]) {

    if (features == null || features.length == 0) {
      return;
    }
    console.log(features);
    for (let featInfo of features) {
      let feat=featInfo.feature;
      let layerinfo: FrLayer = feat.frlayerinfo;
      if (layerinfo) {
        if (layerinfo.ref == OlObjectTypeEnum.panel) {
          console.log("panel clicked", layerinfo);
          let panel: Panel = layerinfo.refObject;
          //let panelType = layerinfo.refObject.panelType;
          let id_panel_type = panel.id_panel_type;
          if (id_panel_type == null) {
            this.showNotificationError("This panel doesn´t have a panel type assigned.")
            return;
          }
          PanelViewComponent.openModal(this.dialog, id_panel_type);
        }
      }
    }
  }

  /**
   * Add boundary geojson
   */
  showChangeSiteBoundariesDialog() {
    let dialogData = {
      title: "Edit Site Boundary"
      , titlesub: "This site boundary is used by internal system."
      , layerName: "Site boundary"
      , layerId: "geom_" + this.site.id
      , layerNameEditable: false
    };
    let dialogRef = this.mapc.layerAddManual(dialogData);
    dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          //result es dialogRef.componentInstance.geojson
          this.changeSiteLimits(result);
        }
      },
      error: (err: any) => {
        console.log(err);
        this.notifyerror(err, "Error creating site boundary");
      },
      complete: () => {
        console.log('complete');
      }
    });
  }

  private changeSiteLimits(result) {
    this.siteLayer = null;
    //brujeria, la misma operacion no funciona
    //this.mapc.layerRemove(result.layerId);
    //this.siteLayer = MapSiteHelper.loadSiteGeometry(result.name, this.site.geom, result.layerId);
    //this.mapc.layerAdd(this.siteLayer);

    //this.mapc.map.render();
    this.siteLayer = this.mapc.loadGeoData(result.name, result.geom, result.layerId);
    let style = new ol_style.Style({
      stroke: new ol_style.Stroke({
        color: [33, 243, 239, 1],
        width: 2,
        lineCap: 'round'
      })
    });
    this.siteLayer.setStyle(style);

    this.sitelimitschange = true;
  }

  cancelSizeLimits() {
    //restore
    const res = { name: "Site boundary", geom: this.site.geom, layerId: "geom_" + this.site.id };
    this.changeSiteLimits(res);
    this.sitelimitschange = false;
  }

  saveSizeLimits() {
    //save to server    
    this.submitted = true;
    this.loading = true;
    this.alertmessage = null;
    try {

      const clonemodel = Object.assign({}, this.site);
      let gj = new GeoJSON();
      let geojsonStr = gj.writeFeatures(this.siteLayer.getSource().getFeatures());
      //console.log(geojsonStr);
      if (geojsonStr == null || geojsonStr.length == 0) {
        this.showerror("No geojson selected");
        return;
      }
      let res = JSON.parse(geojsonStr);
      if (res == null || res.features.length == 0) {
        this.showerror("No geojson selected");
        return;
      }
      clonemodel.geom = res.features[0].geometry;
      //console.log(clonemodel.geom);
      this.solarService.siteEditCreate(clonemodel)
        .subscribe((res) => this.savehandleresult(res), err => this.savehandleError(err)
        );
    } catch (error) {
      this.submitted = false;
      this.loading = false;
      this.showerror(error);
      console.log(error);
    }
  }

  savehandleresult(resultmodel: Site) {
    console.log("site saved", resultmodel);
    this.submitted = false;
    this.loading = false;
    this.showmessage('Site saved');


    this.site.name = resultmodel.name;
    this.site.description = resultmodel.description;
    this.site.info = resultmodel.info;
    this.site.geom = resultmodel.geom;
    this.sitelimitschange = false;

  }

  savehandleError<T>(err: any) {
    this.handleError(err);
  }

  handleError<T>(err: any) {
    this.submitted = false;
    this.loading = false;
    this.showerror("Error saving site. Message: " + err.message);
    console.error('An error occurred:', err.message);
  }

  /**
   * para cambiar la ortho hay que preparar una upload al sistema porque  puede llevar una gran volumen de datos
   * esperar la respuesta y actualizar. 
   */
   showChangePanelsDialog() {
    this.editAction = new LayerEditAction();
    this.editAction.newLayerId = MapPanelSourceHelper.LAYER_SITE_PANELS + "_" + UUIDHelper.uuidv4();

    let dialogData = {
      title: "Load Site Panels"
      , titlesub: "Vector panel layer is used by internal system to locate panels."
      , layerName: "New Vector Panels"
      , layerId: this.editAction.newLayerId
      , layerNameEditable: false
      ,site:this.site
    };
    let dialogRef = PanelLayerAddComponent.openModal(this.dialog, dialogData);
    dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          //result es dialogRef.componentInstance.geojson
          this.loadNewSitePanelsVectorLayer(result);
        }
      },
      error: (err: any) => {
        console.log(err);
        this.notifyerror(err, "Error loading panels layer");
      },
      complete: () => {
        //console.log('complete');
      }
    });
  }

  private loadNewSitePanelsVectorLayer(result) {
    try {
      this.showNotificationInfo("GeoAI is procesing your request. You need to reload panels in a few minutes.");
      return;
    }
    catch (error) {
      this.showNotificationError("Error loading json file.",error);
    }
  }


  showChangeDTMDialog(){
    let formData=[];
    formData.push(["info", JSON.stringify({"upload_type":"dtm"})]);
    let dialogData = {
      title: "Add DTM to the site"
      , titlesub: ""
      , acceptFilter:".tif" 
      , fileMessagePlaceholder:"Choose TIF file to upload"
      , handleResultMessage: "DTM file uploaded succesfully."
      , target_data: this.site.id
      , serviceCallback: this.solarService.siteUploadFile.bind(this.solarService)
      , formData: formData
    };
    let dialogRef = UploadSimpleFileComponent.openModal(this.dialog,dialogData);
    dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          //result es dialogRef.componentInstance.geojson
         console.log("Upload complete");
        }
      },
      error: (err: any) => {
        console.log(err);
        this.notifyerror(err, "Error uploading site DTM");
      },
      complete: () => {
        console.log('complete');
      }
    });
  }

  showChangeOrthoDialog(){
    let formData=[];
    formData.push(["info", JSON.stringify({"upload_type":"ortho"})]);
    let dialogData = {
      title: "Add Ortho to the site"
      , titlesub: ""
      , acceptFilter:".tif" 
      , fileMessagePlaceholder:"Choose TIF file to upload"
      , handleResultMessage: "Ortho file uploaded succesfully."
      , target_data: this.site.id
      , serviceCallback: this.solarService.siteUploadFile.bind(this.solarService)
      , formData: formData
    };
    let dialogRef = UploadSimpleFileComponent.openModal(this.dialog,dialogData);
    dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          //result es dialogRef.componentInstance.geojson
         console.log("Upload complete");
        }
      },
      error: (err: any) => {
        console.log(err);
        this.notifyerror(err, "Error uploading site Ortho");
      },
      complete: () => {
        console.log('complete');
      }
    });
  }


}

class LayerEditAction {

  newLayerId: string;
  save: Function;
  cancel: Function;
  geoJson: any;
  file: File;

}
